import React, { useState } from 'react';

export function buildPublicEventSharePaths({ publicEventsSlug = '', publicSlug = '', occurrenceId = '' } = {}) {
  if (!publicEventsSlug || !publicSlug) return { clubPath: '', eventPath: '' };
  const clubPath = `/events/${publicEventsSlug}`;
  const occurrence = occurrenceId ? `?occurrence=${encodeURIComponent(occurrenceId)}` : '';
  return { clubPath, eventPath: `${clubPath}/${publicSlug}${occurrence}` };
}

async function copyPath(path) {
  if (!path || typeof window === 'undefined' || !navigator?.clipboard) return false;
  await navigator.clipboard.writeText(`${window.location.origin}${path}`);
  return true;
}

export default function PublicEventShareActions({ form, isAdmin = false, justCreated = false, compact = false }) {
  const [copied, setCopied] = useState('');
  const { clubPath, eventPath } = buildPublicEventSharePaths(form);
  if (!isAdmin || !form?.allowNonMembers || !eventPath) return null;

  const handleCopy = async (key, path) => {
    try {
      if (!await copyPath(path)) return;
      setCopied(key);
      window.setTimeout(() => setCopied(current => current === key ? '' : current), 2200);
    } catch {
      setCopied('error');
    }
  };

  return <section className={`public-event-share ${compact ? 'public-event-share--compact' : ''}`} aria-label="Share public event">
    <div>
      <strong>{justCreated ? 'Event created — ready to share' : 'Share this public event'}</strong>
      {!compact && <p>Anyone can view this page. They’ll be asked to create or sign into a Member Nest account before buying.</p>}
    </div>
    <div className="public-event-share__actions">
      <button type="button" className="button button-primary" onClick={() => handleCopy('event', eventPath)}>
        {copied === 'event' ? 'Event link copied' : 'Copy event link'}
      </button>
      <a className="button button-secondary" href={eventPath} target="_blank" rel="noreferrer">Open public page</a>
      <button type="button" className="button button-secondary" onClick={() => handleCopy('club', clubPath)}>
        {copied === 'club' ? 'Club page copied' : 'Copy club events page'}
      </button>
    </div>
    <span className="sr-only" aria-live="polite">{copied === 'error' ? 'Could not copy the link.' : copied ? 'Link copied.' : ''}</span>
  </section>;
}
